import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export const useMdBreakpoint = () => {
  const theme = useMantineTheme();
  const mdBreakpoint = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);
  return mdBreakpoint;
};
